module.exports = __webpack_public_path__ + "static/media/ikonnect.4f78f606.jpg";